// Compay Ödeme Raporu Modelleri

export interface CompayPaymentListRequest {
  StartDate: Date
  EndDate: Date
  Status?: string // 'SUCCESS' | 'FAIL' | 'PENDING' | 'ALL'
  PaymentType?: string // 'CART' | 'SERIAL' | 'ALL'
  DealerCode?: string
  Company?: number
  OrderId?: string
  CustomerTcNo?: string
}

export interface CompayPaymentItem {
  Id: number
  OrderId: string
  DealerCode: string
  DealerName: string
  CompanyCode: string
  CompanyName: string
  PaymentType: string // 'CART' | 'SERIAL'
  PaymentTypeName: string
  Amount: number
  AmountTL: number
  CurrencyType: string
  Status: string
  StatusName: string
  AuthCode: string
  RefNum: string
  ErrorMessage?: string
  CreatedAt: Date
  UpdatedAt?: Date
  // Müşteri Kredisi için ek alanlar
  CreditUserType?: string // 'DEALER' | 'CUSTOMER'
  // Bayi Kar Marjı alanları
  DealerMarkupPercentage?: number
  DealerMarkupAmount?: number
  FinalPrice?: number
  MarkupInputMode?: string // 'percentage' | 'price'
  // Seri Numaralı Kredi için
  SerialNumber?: string
  ProductCode?: string
  InvoiceNumber?: string
}

export interface CompayPaymentListResponse {
  Payments: CompayPaymentItem[]
  TotalCount: number
  TotalAmount: number
  TotalAmountTL: number
  SuccessCount: number
  FailCount: number
  PendingCount: number
  TotalDealerMarkup: number
}

// Alışveriş Kredisi Raporu Modelleri

export interface ShoppingCreditListRequest {
  StartDate: Date
  EndDate: Date
  Status?: string // 'APPROVED' | 'REJECTED' | 'PENDING' | 'ALL'
  CreditType?: string // 'CART' | 'SERIAL' | 'ALL'
  CreditUserType?: string // 'DEALER' | 'CUSTOMER' | 'ALL'
  DealerCode?: string
  Company?: number
  OrderId?: string
  SerialNumber?: string
  CustomerTcNo?: string
  PageNumber?: number
  /** 0 gönderilirse backend sayfalama yapmaz, tüm kayıtları döner. */
  PageSize?: number
}

export interface ShoppingCreditItem {
  Id: number
  OrderId: string
  DealerCode: string
  DealerName: string
  CompanyCode: string
  CompanyName: string
  CreditType: string // 'CART' | 'SERIAL'
  CreditTypeName: string
  CreditUserType: string // 'DEALER' | 'CUSTOMER'
  CreditUserTypeName: string
  BaseAmount: number
  FinalAmount: number
  DealerMarkupAmount: number
  DealerMarkupPercentage: number
  CurrencyType: string
  Status: string
  StatusName: string
  // Müşteri bilgileri (CreditUserType = CUSTOMER için)
  CustomerTcNo?: string
  CustomerPhone?: string
  CustomerFullName?: string
  // Seri numaralı kredi için
  SerialNumber?: string
  ProductCode?: string
  ProductName?: string
  InvoiceNumber?: string
  // Onay bilgileri
  AuthCode?: string
  RefNum?: string
  ErrorMessage?: string
  CreatedAt: Date
  ApprovedAt?: Date
  UpdatedAt?: Date
}

export interface ShoppingCreditListResponse {
  Success?: boolean
  Credits: ShoppingCreditItem[]
  TotalCount: number
  PageNumber?: number
  PageSize?: number
  TotalPages?: number
  TotalBaseAmount: number
  TotalFinalAmount: number
  TotalDealerMarkup: number
  ApprovedCount: number
  RejectedCount: number
  PendingCount: number
  DealerCreditCount: number
  CustomerCreditCount: number
  ErrorMessage?: string
}

// Compay Ödeme Detayı

export interface CompayPaymentDetailRequest {
  OrderId: string
}

export interface CompayPaymentDetailResponse {
  Payment: CompayPaymentItem
  TransactionHistory: CompayTransactionHistory[]
}

export interface CompayTransactionHistory {
  Id: number
  OrderId: string
  Action: string
  Status: string
  Message: string
  CreatedAt: Date
}

// İptal/İade İşlemi

export interface CompayCancelRequest {
  OrderId: string
  Reason: string
  Amount?: number // Kısmi iade için
}

export interface CompayCancelResponse {
  Success: boolean
  Message: string
  RefundOrderId?: string
}

// Dashboard İstatistikleri

export interface CompayDashboardRequest {
  StartDate: Date
  EndDate: Date
  Company?: number
}

export interface CompayDashboardResponse {
  TotalPayments: number
  TotalAmount: number
  SuccessRate: number
  AverageAmount: number
  PaymentsByDay: DailyPaymentStat[]
  PaymentsByType: TypePaymentStat[]
  PaymentsByCompany: CompanyPaymentStat[]
  TopDealers: DealerPaymentStat[]
}

export interface DailyPaymentStat {
  Date: string
  Count: number
  Amount: number
  SuccessCount: number
  FailCount: number
}

export interface TypePaymentStat {
  PaymentType: string
  PaymentTypeName: string
  Count: number
  Amount: number
  Percentage: number
}

export interface CompanyPaymentStat {
  CompanyCode: string
  CompanyName: string
  Count: number
  Amount: number
  Percentage: number
}

export interface DealerPaymentStat {
  DealerCode: string
  DealerName: string
  Count: number
  Amount: number
}

// Status seçenekleri
export const PaymentStatusOptions = [
  { value: 'ALL', label: 'Tümü' },
  { value: 'SUCCESS', label: 'Başarılı' },
  { value: 'FAIL', label: 'Başarısız' },
  { value: 'PENDING', label: 'Beklemede' },
]

export const CreditStatusOptions = [
  { value: 'ALL', label: 'Tümü' },
  { value: 'APPROVED', label: 'Onaylı' },
  { value: 'REJECTED', label: 'Reddedildi' },
  { value: 'PENDING', label: 'Beklemede' },
]

export const PaymentTypeOptions = [
  { value: 'ALL', label: 'Tümü' },
  { value: 'CART', label: 'Sepet Ödemesi' },
  { value: 'SERIAL', label: 'Seri No ile Ödeme' },
]

export const CreditUserTypeOptions = [
  { value: 'ALL', label: 'Tümü' },
  { value: 'DEALER', label: 'Bayi Kredisi' },
  { value: 'CUSTOMER', label: 'Müşteri Kredisi' },
]

export interface CompayPaymentSettings {
  MaxDealerMarkupPercentage?: number
  MinDealerMarkupPercentage?: number
  IsCustomerCreditEnabled?: boolean
  IsDealerCreditEnabled?: boolean
  RequireCustomerTcNo?: boolean
  RequireCustomerName?: boolean
  SapProfitTransferEnabled?: boolean
  DefaultCreditUserType?: string
}

export interface CompayPaymentCategorySettings {
  Id: number
  CategoryName: string
  IsActive: boolean
  MaxPrice?: number
  MinPrice?: number
}

export interface CompayPaymentContractReport {
  DealerSapCode: string
  DealerName: string
  FileUrl: string
  ApprovedDate: Date
}